import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, MutationAction, getModule } from 'vuex-module-decorators';
import AgencyDto from '@/models/Agencies/AgencyDto';
import store from '@/store';
import UpdateAgencyGeneralDetailsRequest from '@/models/Agencies/UpdateAgencyGeneralDetailsRequest';
import UpdateAgencyProfileDetailsRequest from '@/models/Agencies/UpdateAgencyProfileDetailsRequest';
import UpdateAgencyAuthenticationRequest from '@/models/Agencies/UpdateAgencyAuthenticationRequest';
import { AppModule } from '@/store/modules/app'
import FileUtils from '@/lib/fileUtils';
import UploadAvatarRequest from '@/models/Avatars/UploadAvatarRequest';
import UpdateAvatarRequest from '@/models/Avatars/UpdateAvatarRequest';
import CreateAgencyRequest from '@/models/Agencies/CreateAgencyRequest';

export interface IAgencyState {
  loadingAgencies: boolean; 
  agencies: AgencyDto[];
  loadingAgency: boolean; 
  currentAgency: AgencyDto | null;
  loadingDialog: boolean;
}

@Module({ dynamic: true, store, name: 'Agency', namespaced: true })
class Agency extends VuexModule implements IAgencyState {
 
  public loadingAgencies = true;
  public agencies: AgencyDto[] = [];
  public loadingAgency = true;
  public currentAgency: AgencyDto = new AgencyDto();
  public loadingDialog = false;
 
  
  @Action
  async index(path: string) {
    ajax.post(`/api/v1/sys/agency/index/${path}`)
    .then(response => {
    })
    .catch(error => {
      AppModule.handleApiError(error);
    });
  }

  @Action
  async getAgencies() {
    this.setLoadingAgencies(true);
    ajax.get('/api/v1/sys/agencies')
    .then(response => {
      this.context.commit("setAgencies", response.data);
      this.setLoadingAgencies(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingAgencies(false);
    });
  }

  @Action
  public async getAgency(agencyId: string) {
    this.setLoadingAgency(true);
    const response = await ajax.get(`/api/v1/sys/agencies/${agencyId}`)
    .then(response => {
      this.context.commit("setCurrentAgency", response.data);
      this.setLoadingAgency(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingAgency(false);
    })
  }

  @Action
  public async createAgency(agency: CreateAgencyRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/sys/agencies`, agency)
    .then(response => {
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editAgencyGeneralDetails(agency: UpdateAgencyGeneralDetailsRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/general-details`, agency)
    .then(response => {
      this.context.commit("setCurrentAgency", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editAgencyProfileDetails(agency: UpdateAgencyProfileDetailsRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/profile-details`, agency)
    .then(response => {
      this.context.commit("setCurrentAgency", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async updateAuthentication(request: UpdateAgencyAuthenticationRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/sys/agencies/${this.currentAgency.id}/sso`, request)
    .then(response => {
      this.context.commit("setCurrentAgency", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  async uploadAvatar(file: File) {

    const fileExtension = "." + file.name.split('.').pop();
    const contentType = FileUtils.cleanContentType(fileExtension, file.type);
    //First get the signed URL
    const uploadRequest = new UploadAvatarRequest();
    uploadRequest.contentType = contentType;
    let destinationFileName = '';

    this.setLoadingDialog(true);
    //this.context.commit("setDocumentUploadUrl", null);
    await ajax.post(`/api/v1/agency/avatar/upload`, uploadRequest)
    .then(uploadResponse => {
      const config = {
        headers: {
          'content-type': contentType
        }
      };
      destinationFileName = uploadResponse.data.destinationFileName;
      return ajax.put(uploadResponse.data.signedUrl, file, config)})
      .then(googleResponse => {
        const updateRequest = new UpdateAvatarRequest();
        updateRequest.fileName = destinationFileName;
      
        ajax.put(`/api/v1/agency/avatar`, updateRequest)
        .then(response => {
          this.context.commit("setCurrentAgency", response.data);
          this.setLoadingDialog(false);
        })
      })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  cleanState() {
    this.context.commit("resetState");
  }

  @Mutation
  resetState() {
    this.currentAgency = new AgencyDto();
    this.agencies = [];
    this.loadingAgencies = true;
    this.loadingAgency = true;
  }

  @Mutation
  private async setLoadingAgencies(isLoading: boolean) {
      this.loadingAgencies = isLoading;
  }

  @Mutation
  private async setAgencies(agencies: AgencyDto[]) {
      this.agencies = agencies;
  }
  
  @Mutation
  private async setCurrentAgency(agency: AgencyDto) {
      if (agency != null) {      
        this.currentAgency = agency;
      }
  }

  @Mutation
  private async setLoadingAgency(isLoading: boolean) {
      this.loadingAgency = isLoading;
  }

  @Mutation
  private async setLoadingDialog(isLoadingDialog: boolean) {
      this.loadingDialog = isLoadingDialog;
  }
}

export const AgencyModule = getModule(Agency)
